import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { getUserSelectedChoices } from './utils/quizUtils';
import { tableAnalysisTwoStatementConfig } from './utils/quizConfigs';

import questionBankIcon from '../../../assets/img/question_bank/question_icon_blue.svg';
import GMATCalculator from '../../../common/Calculator/GMATCalculator';
import ComponentHeader from '../../../common/ComponentHeader';
import CustomButton from '../../../common/CustomButton';
import { onHandleTableSorting, renderHTMLContent } from '../../../common/function';
import { messages } from '../../../common/messages';
import FlashCard from '../../../components/FlashCard';
import ValidateSaveReportIcon from '../../../views/Common/ValidateSaveReportIcon';
import CustomCard from '../../QuestionBank/CustomCard';
import CustomCardBody from '../../QuestionBank/CustomCardBody';
import CustomCardHeader from '../../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../../QuestionBank/LoaderWrapper';
import ReportComponent from '../../ReportComponent';
import { QUESTION_TYPE } from '../../../common/constant';
import TableSort from '../TableSort';

export default class TableAnalysisTwoStatement extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      selectedAnswer1: '',
      selectedAnswer2: '',
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      showCalculator: false,
      isError: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    await this.handleSetCurrentQuestion();
  }
  async componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
      this.handleSetCurrentQuestion();
    }
  }
  setUserSelectedChoices = async () => {
    const { params, questionIds, questionTypes, apiServices, onHandleSetTimer } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];

    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.checkUserSelectedAnswer(payload);
    const { currentQuestion } = this.state;
    const received = response.question_recived || {};

    const { selectedOptions, extraState } = getUserSelectedChoices({
      question: currentQuestion,
      stat: received,
      config: tableAnalysisTwoStatementConfig,
    });

    if (selectedOptions && Object.keys(selectedOptions).length > 0) {
      this.setState({
        selectedOptions,
        ...selectedOptions,
        ...extraState,
      });
    } else {
      this.setState({
        ...tableAnalysisTwoStatementConfig.extractExtraState(selectedOptions, received),
        ...selectedOptions,
        selectedOptions,
      });
    }

    onHandleSetTimer(!response.question_recived, !!response.question_recived);
  };

  handleSetCurrentQuestion = async () => {
    const { params, questionIds, questionTypes, apiServices } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];

    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.getQuestionById(payload);
    const { questionsbyid: currentQuestion } = response;
    const { question, sortBy } = currentQuestion;
    /**
     * Navigates to a specific question by index, updates component state with the selected question's
     * content and table (if present), and fetches saved question data and rating.
     *
     * Working:
     * - Splits the question text and table HTML to allow rendering a dropdown between them.
     * - Updates state with question content, table, and sorting options.
     * - Triggers fetch for saved question and rating.
     *
     * Unable to change:
     * - The split and state update logic must remain as is to support inserting a dropdown between the question and table.
     *
     * @param {number} index - The index of the question to navigate to.
     */
    const [questionText, tableContent] = question.split('<table');
    const questionContent = questionText || question;
    const questionTable = tableContent
      ? `<table id="myTable" border="1" cellpadding="5px" ${tableContent}`
      : '';
    const sortingOptions = (sortBy && sortBy.split(',')) || [];
    this.setState(
      {
        questionContent,
        questionTable,
        sortingOptions,
        currentIndex: parseInt(offset, 10) || 0,
        currentQuestion: currentQuestion || {},
      },
      () => {
        this.getSavedQuestion(currentQuestionId);
        this.setUserSelectedChoices();
      },
    );
  };

  handleSaveQuestion = async () => {
    const { currentQuestion, reading, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id: currentQuestion.id,
      type,
      topic_name,
      reading_id,
    };

    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  resetStates = () => {
    this.setState({
      validated: false,
      isLoading: true,
      selectedAnswer1: '',
      selectedAnswer2: '',
      isError: false,
      selectedOptions: {},
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  getPreviousQuestion = async () => {
    const { currentIndex } = this.state;
    const { handleChangeParams } = this.props;
    if (currentIndex > 0) {
      handleChangeParams(currentIndex - 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  getNextQuestion = async () => {
    const { currentIndex } = this.state;
    const { questionIds, handleChangeParams } = this.props;
    const nextIndex = currentIndex + 1;
    if (nextIndex < Object.keys(questionIds).length) {
      handleChangeParams(currentIndex + 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  handleSelect = (type, value) => {
    this.setState({ [type]: value });
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { selectedOptions, currentQuestion } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { quiz_id },
      onHandleSetTimer,
    } = this.props;
    if (Object.keys(selectedOptions).length !== 3) {
      this.setState({ isError: true });
      return;
    }
    let isCorrect = true;
    isCorrect = Object.keys(currentQuestion)
      .filter((key) => key.startsWith('answer'))
      .every((key) => {
        const optionKey = key.replace('answer', 'option');
        return String(currentQuestion[key]).trim() === String(selectedOptions[optionKey]).trim();
      });

    const selectedChoice = JSON.stringify(selectedOptions);

    onHandleSetTimer(false, true);

    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: isCorrect ? 1 : 0,
      answer: isCorrect ? 1 : 0,
      quiz_id,
      selected_choice: selectedChoice,
      type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      await apiServices.saveQuizAnswer(payload);
    }
  };

  handleChoicesSelect = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      selectedOptions: {
        ...prevState.selectedOptions,
        [name]: value,
      },
      isError: false,
    }));
  };

  renderOptions = () => {
    const { validated, currentQuestion, selectedOptions = {} } = this.state;

    // Create entries like { key: "option1", value: "yes" }
    const optionEntries = Object.entries(currentQuestion)
      .filter(([key]) => key.startsWith('option'))
      .map(([key, value]) => ({ key, value }));

    return optionEntries.map((optionValue, index) => {
      const optionKey = optionValue.key; // e.g., "option1"
      const answerKey = optionKey.replace('option', 'answer'); // maps to "answer1"
      const correctAnswer = currentQuestion[answerKey]; // e.g., "yes"

      return (
        <tr key={optionKey}>
          {['yes', 'no'].map((choiceValue) => {
            const isSelectedChoice = selectedOptions[optionKey] === choiceValue;

            // Determine class if validated
            let validationClass = '';
            if (validated && isSelectedChoice) {
              validationClass =
                String(choiceValue).trim() === String(correctAnswer).trim()
                  ? 'accent-success'
                  : 'accent-faliure';
            }

            return (
              <td
                className={`border-solid-1 p-10px ${validationClass}`}
                key={`${optionKey}-${choiceValue}`}
              >
                <input
                  type='radio'
                  name={optionKey}
                  className='border-solid'
                  checked={isSelectedChoice}
                  value={choiceValue}
                  disabled={!validationClass && validated}
                  onChange={this.handleChoicesSelect}
                />
              </td>
            );
          })}
          <td className='border-solid-1 p-10px'>{optionValue.value}</td>
        </tr>
      );
    });
  };
  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };


  resetTableContent = () => {
    const { currentQuestion } = this.state;
    this.setState(
      {
        questionTable: '',
      },
      () => {
        this.setState({
          questionTable: `<table id="myTable" border="1" cellpadding="5px" ${
            currentQuestion.question.split('<table')
              ? currentQuestion.question.split('<table')[1]
              : currentQuestion.question
          }`,
        });
        document.getElementById('table_data_select').selectedIndex = 0;
      },
    );
  };
  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      isError,
      showCalculator,
      questionContent,
      questionTable,
      sortingOptions,
    } = this.state;
    const { apiServices, params, redirectToResults, questionType, questionIds, examName } = this.props;
    // Quiz routes don't expose question_id / readingid / reading in URL params;
    // pull report fields from currentQuestion + questionType so /reportQuestion
    // gets real values instead of undefined → NULL rows in *_ques_reports.
    const { offset, quiz_id: quizId } = params;
    const question_id = currentQuestion && currentQuestion.id;
    const reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
    const topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
    const type = questionType;

    return (
      <div>
        <ComponentHeader title={`${messages.QUIZ_ID}: ${quizId}`}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() =>
                this.setState({
                  showCalculator: true,
                })
              }
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectToResults()}>
              {messages.BACK_TO_SUMMARY}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          {currentQuestion && Object.keys(currentQuestion).length ? (
            <CustomCard>
              <CustomCardHeader
                headingText={`(Q. ${parseInt(offset, 10) + 1})`}
                headerImage={questionBankIcon}
                arrayLength={Object.keys(questionIds).length}
                showPreviousButton
                showNextButton
                disabledPreviousButton={currentIndex < 1}
                disabledNextButton={currentIndex >= Object.keys(questionIds).length - 1}
                getPreviousQuestion={this.getPreviousQuestion}
                getNextQuestion={this.getNextQuestion}
              />
              <CustomCardBody>
                <Row>
                  <Col xs={10} sm={12} lg={10} className='mb-0 font-16px mb-sm-1 question-view'>
                    <div className='card-block  statement-question-div'>
                      {renderHTMLContent(
                        questionContent || currentQuestion.question,
                        'div',
                        'text-justify',
                      )}
                      <TableSort
                        sortOptions={sortingOptions}
                        onSortChange={(value) => onHandleTableSorting(value)}
                        onReset={this.resetTableContent}
                      />
                      {renderHTMLContent(questionTable, 'div', 'overflow-x-auto table-w-100')}
                    </div>
                    <table className='text-center  margin_bottom_30'>
                      <thead>
                        <tr>
                          <th className='p-10px'>{currentQuestion.choice_a}</th>
                          <th className='p-10px'>{currentQuestion.choice_b}</th>
                          <th className='p-10px' />
                        </tr>
                      </thead>
                      <tbody>{this.renderOptions()}</tbody>
                    </table>
                    {isError && (
                      <Col sm={12} md={12} lg={12} className='text-danger text-left  mb-0 pb-0'>
                        {messages.SELECT_OPTION_ERROR}
                      </Col>
                    )}
                    <div className='text-center mt-3 d-flex'>
                      {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
                      <ValidateSaveReportIcon
                        isQue={true}
                        showResult={validated}
                        _getResult={this.handleValidate}
                        _saveQuestion={this.handleSaveQuestion}
                        _displayReportForm={this.reportCardToggle}
                        all_questions={questionData}
                        save_text={saveTooltipTitle}
                        bookmarkCSS={bookmarkCSS}
                        bookmarkColor={bookmarkColor}
                      />
                    </div>
                  </Col>
                  <Col xs={2} sm={12} lg={2} className='text-center'>
                    {this.props.children}
                  </Col>
                </Row>
              </CustomCardBody>
            </CustomCard>
          ) : (
            <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
          )}
        </LoaderWrapper>

        {validated && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                  className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
                />
                <CustomCardBody>
                  {renderHTMLContent(currentQuestion.explanation, 'span')}
                </CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        <FlashCard
          item={{ id: currentQuestion && currentQuestion.id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        {/* //TODO: Remove the ! from the common component */}
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/Quiz/TableAnalysisTwoStatement.jsx